import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Alert, AlertActions, AlertDescription, AlertTitle } from '@/common/components/alert';
import { Button } from '@/common/components/button';
import { useDeleteContact } from '@/contacts/queries';

export function DeleteContact({ contactId }: { contactId: number }) {
  const navigate = useNavigate();
  const deleteContactMutation = useDeleteContact({
    mutationConfig: {
      onSuccess: () => {
        setIsOpen(false);
        void navigate({ to: '/contacts' });
      }
    }
  });

  const [isOpen, setIsOpen] = useState(false);

  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  function deleteContact() {
    deleteContactMutation.mutate({ contactId });
  }

  return (
    <>
      <Button outline color="red" onClick={open}>Delete Contact</Button>
      <Alert onClose={setIsOpen} open={isOpen}>
        <AlertTitle>Delete Contact</AlertTitle>
        <AlertDescription>
          Are you sure you want to delete this contact? This action is permanent and cannot be undone.
        </AlertDescription>
        <AlertActions>
          <Button outline onClick={close}>
            Cancel
          </Button>
          <Button color="red" disabled={deleteContactMutation.isPending} onClick={deleteContact}>
            Delete Contact
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
}
